import React from 'react';
import styled from 'styled-components';
import useFeatureToggle from 'Client/hooks/useFeatureToggle';
import useBellaTranslator from 'Client/hooks/useTranslator';
import useTheme from 'Client/hooks/useTheme';

interface Props {
    quantity: number;
    disabled: boolean;
    inline?: boolean;
}

const ColorSpan = styled.span<{ color: string }>`
    color: ${({ color }) => color};
`;

const SizeSelectorNote: React.FC<Props> = ({ quantity, disabled, inline = true }) => {
    const t = useBellaTranslator();
    const { p100PdpSizeSelectorNote } = useFeatureToggle();
    const theme = useTheme();
    let color = p100PdpSizeSelectorNote === 'charcoal' ? theme.colors.charcoal100 : theme.colors.red100;
    const prefix = inline ? ' - ' : '';

    if (disabled) {
        color = p100PdpSizeSelectorNote === 'charcoal' ? theme.colors.charcoal10 : theme.colors.red10;
    }
    if (!p100PdpSizeSelectorNote || p100PdpSizeSelectorNote === 'no_note') {
        return null;
    }
    if (quantity === 1) {
        return <ColorSpan data-testid="note" color={color}>{`${prefix}${t('Only 1 left')}`}</ColorSpan>;
    }
    if (quantity > 0 && quantity <= 3) {
        return <ColorSpan data-testid="note" color={color}>{`${prefix}${t('Low stock')}`}</ColorSpan>;
    }
    return null;
};

export default SizeSelectorNote;
